export enum ScheduledReportLoginType {
    PASSWORD = 1,
    KEY = 2,
}
